export default "__VITE_ASSET__TSh79pqZ__"